import React from "react"
import { BulletTabs } from "../../components/BulletTabs"
import { Button, ButtonLoader } from "../../components/Button"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { Input, InputTextArea, Label, SelectInput } from "../../components/Form"
import IndicatorsContainer from "../../container/IndicatorsContainer"
import systemChat from "../../assets/icons/system-chat-toggle.svg"
import moment from "moment"
import "./styles.scss"
import { Tag } from "antd"
import { PickerWithType } from "../../components/DatePicker"
import { isMobile } from "react-device-detect"
import TagInput, { TagList } from "../../components/TagSelect"
import { HiOutlinePencil } from "react-icons/hi"
import { MdChat, MdDelete } from "react-icons/md"
import ModalAlert from "../../components/ModalAlert"
import { TaskTableContainer } from "../../container/ActionPlanTaskTableContainer"
import { BsFiletypeXlsx } from "react-icons/bs"
import { statusOptions } from "../../container/ActionPlanContainer"
import { IoFilterOutline } from "react-icons/io5"

export const ActionPlanAdd = ({
  modalOpen,
  modalOpenEdit,
  setModalOpen,
  formSteps,
  editedChatFields,
  values,
  handleEdit,
  handleSave,
  handleCancel,
  loadingField,
  loadingActionSave,
  onChangeQuestionsInfo,
  editIndex,
  indicatorTabsOptions,
  handleSaveAction = () => { },
  handleUpdateAction = () => { },
  onChangeValues = () => { },
  handleSelectedIndicator,
  technicalList,
  handleActiveIndicator,
}) => {

  console.log("DD", values)
  const reviewer =
    values?.reviewer ||
    (values?.reviewerId ? technicalList.find((item) => item.value === values.reviewerId) : {})

  return (
    <ModalPanel width={900} modalIsOpen={modalOpen} shouldCloseOnOverlayClick={true}>
      <ModalHeader
        closeModal={() => setModalOpen(false)}
        title={modalOpenEdit ? "Alterar ação" : "Adicionar uma nova ação"}
      />
      <ModalBody hideScroll className="add-action-modal-body">
        <div className="add_actions__container">
          <div className="add_actions__container-5w2h">
            <div className="fields">
              <Label label="Dê um nome a ação que será realizada" />
              <Input
                placeholder="Escreva um título para ação"
                isNormal={false}
                name="title"
                value={values?.title || ""}
                onChange={onChangeValues}
              />
              <Label label="Onde será realizada a ação" />
              <Input
                placeholder="Informe o local que a ação será realizada"
                isNormal={false}
                name="location"
                value={values?.location || ""}
                onChange={onChangeValues}
              />
              <Label label="Responsável Interno" />
              <Input
                placeholder="Insira o email do responsável (Técnico ManejeBem)"
                isNormal={false}
                name="internal_responsible"
                value={values?.internal_responsible || ""}
                onChange={onChangeValues}
              />
              <Label label="Responsável Externo" />
              <Input
                placeholder="Insira o email do responsável (Técnico Externo)"
                isNormal={false}
                name="external_responsible"
                value={values?.external_responsible || ""}
                onChange={onChangeValues}
              />
              <div className="fields-date">
                <Label label="Em quanto tempo será realizada" />
                <div className="flex-inputs">
                  <Input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    isNormal={false}
                    name="start_at"
                    value={moment(values?.start_at).format("YYYY-MM-DD") || ""}
                    onChange={onChangeValues}
                  />
                  <Input
                    type="date"
                    placeholder="DD/MM/YYYY"
                    isNormal={false}
                    name="finish_at"
                    value={moment(values?.finish_at).format("YYYY-MM-DD") || ""}
                    onChange={onChangeValues}
                  />
                </div>
              </div>
              <div className="tec_select">
                <Label label="Precisa que alguém aprove?" />
                <SelectInput
                  options={technicalList}
                  isSearchable
                  value={reviewer}
                  handleChange={(value) => onChangeValues({ target: { name: "reviewer", value } })}
                  isOverModal={true}
                />
              </div>
            </div>
            <div className="fields">
              <Label label="Por que será realizada a ação" />
              <InputTextArea
                placeholder="Informe o porquê será realizada a ação"
                resize="none"
                name="why"
                value={values?.why || ""}
                onChange={onChangeValues}
              />
              <Label label="Como será realizada a ação" />
              <InputTextArea
                placeholder="Informe as instruções para se realizar a ação"
                resize="none"
                name="instructions"
                value={values?.instructions || ""}
                onChange={onChangeValues}
              />
              {values?.creatorName &&
                <>
                  <Label label="Criada por: " />
                  <Input
                    type="text"
                    isNormal={false}
                    isDisabled={true}
                    name="creatorName"
                    value={values?.creatorName || "111"} />
                </>
              }
            </div>
          </div>
          {formSteps?.length > 0 && (
            <div className="add_actions__container-link-indicator">
              <span className="link-indicator-title">Vincular a um indicador</span>
              {indicatorTabsOptions && indicatorTabsOptions?.length > 0 && (
                <div className="link-indicator-tabs">
                  <BulletTabs
                    options={indicatorTabsOptions}
                    values={
                      indicatorTabsOptions?.filter(
                        (item) => item.label === formSteps[0]?.category,
                      )[0]
                    }
                    onSelect={handleActiveIndicator}
                  />
                </div>
              )}
              <IndicatorsContainer
                {...{
                  editedChatFields,
                  values,
                  handleEdit,
                  handleSave,
                  handleCancel,
                  loadingField,
                  onChangeQuestionsInfo,
                  editIndex,
                  formSteps,
                  handleSelectedIndicator,
                  allFields: [],
                }}
                hasCheckBox={true}
              />
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonLoader
          label={modalOpenEdit ? "Confirmar" : "Salvar"}
          handleClick={modalOpenEdit ? handleUpdateAction : handleSaveAction}
          messageProcess="Salvando..."
          loading={loadingActionSave}
        />
      </ModalFooter>
    </ModalPanel>
  )
}

export const ActionPlanCommentAdd = ({ modalOpen, handleCloseModalComment, values, commentEdit, onChangeValues, handleCreateComment, handleUpdateComment, loadingSaveComments }) => {
  return (
    <ModalPanel width={600} modalIsOpen={modalOpen} shouldCloseOnOverlayClick={true}>
      <ModalHeader closeModal={() => handleCloseModalComment()} title={commentEdit?.message ? "Editar Comentário" : "Adicionar Comentário"} />
      <ModalBody hideScroll className="add-action-modal-body">
        <div className="add_actions__container">
          <div className="add_actions__container-comments">
            <div className="fields">
              <InputTextArea
                placeholder="Adicione comentários para esta ação"
                resize="none"
                name="comments"
                value={values?.comments || ""}
                onChange={onChangeValues}
              />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ButtonLoader
          label="Salvar"
          handleClick={commentEdit?.message ? handleUpdateComment : handleCreateComment}
          messageProcess="Salvando..."
          loading={loadingSaveComments}
        />
      </ModalFooter>
    </ModalPanel>
  )
}

export const ActionPlanFilter = ({
  modalOpen,
  setModalOpen,
  changeFilter,
  filter,
  uniqueEmails,
  tagPossibility,
  projects
}) => {
  return (
    <ModalPanel width={500} modalIsOpen={modalOpen} shouldCloseOnOverlayClick={true}>
      <ModalHeader closeModal={() => setModalOpen(false)} title="Filtrar" />
      <ModalBody hideScroll className="action-plan-filter-modal-body">
        <div className="action-plan-filter-fields">
          <div className="header-period">
            <PickerWithType
              onChange={(value) => changeFilter("date", value)}
              isWhite={false}
              value={filter?.date}
              placeholder={["Período inicial", "Período final"]}
            />
          </div>
          <div className="header-status">
            <SelectInput
              handleChange={(value) => changeFilter("status", value)}
              defaultValue={filter?.status}
              options={statusOptions}
              breakLine={false}
              isClearable={true}
              placeholder={"Status"}
              isOverModal={true}
              isMulti={true}
              isSearchable={true}
            />
          </div>
          {Array.isArray(projects) && projects.length > 0 && <div className="header-status">
            <SelectInput
              handleChange={(value) => changeFilter("projects", value)}
              defaultValue={filter?.projects}
              options={projects}
              breakLine={false}
              isClearable={true}
              placeholder="Projeto"
              isOverModal={true}
              isMulti={true}
              isSearchable={true}
            />
          </div>}
          <div className="header-responsible">
            <SelectInput
              handleChange={(value) => changeFilter("responsible", value)}
              defaultValue={filter?.responsible}
              options={uniqueEmails}
              isSearchable={true}
              breakLine={false}
              isClearable={true}
              placeholder={"Responsável"}
              isOverModal={true}
            />
          </div>
          <div className="header-status">
            <SelectInput
              handleChange={(value) => changeFilter("tags", value)}
              defaultValue={filter?.tags}
              options={
                Array.isArray(tagPossibility)
                  ? tagPossibility?.map((item) => ({ value: item, label: item }))
                  : []
              }
              isSearchable={true}
              breakLine={false}
              isClearable={true}
              placeholder={"Tags"}
              isOverModal={true}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button label="Confirmar" color="orange" handleClick={() => setModalOpen(false)} />
      </ModalFooter>
    </ModalPanel>
  )
}

export const ActionButton = ({ icon: Icon, description = "Ação", onClick }) => (
  <button
    title={description}
    style={{
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
    }}
    onClick={onClick}>
    <Icon style={{ color: "#afbcaf", fontSize: "18px" }} />
  </button>
)

export const columsActionTable = (
  handleCompleteAction,
  handleOpenModalComment = () => { },
  handleDeleteAction,
  changeTag,
  handleModalOpenEdit,
  tagPossibility,
  showActions = false,
  userId,
) => {
  const assistanceColumns = showActions
    ? [
      {
        title: " ",
        width: "30px",
        render: (props) => (
          <ActionButton
            description="Editar"
            icon={HiOutlinePencil}
            onClick={() => handleModalOpenEdit(props)}
          />
        ),
      },
      {
        title: " ",
        width: "30px",
        render: (props) => (
          <ActionButton
            description="Excluir"
            icon={MdDelete}
            onClick={() =>
              ModalAlert.danger({
                title: "Excluir Ação",
                text: `Você deseja mesmo excluir esta ação ?`,
                confirmLabel: "Sim",
                onConfirm: () => handleDeleteAction(props?.actionId),
              })
            }
          />
        ),
      },
    ]
    : [{}]

  const showCollumns = !userId
    ? [
      {
        title: "Projeto",
        dataIndex: "project",
        key: "project",
      },
      {
        title: "Produtor",
        dataIndex: "producerName",
        key: "producerName",
      },
    ]
    : [{}]

  return [
    ...showCollumns,
    {
      title: "Título",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Termina em",
      dataIndex: "finish_at",
      key: "finish_at",
      render: (finish_at) => finish_at && moment(finish_at).utc().format("DD/MM/YYYY"),
    },
    {
      title: "Responsável Interno",
      dataIndex: "internal_responsible",
      key: "internal_responsible",
    },
    {
      title: "Responsável Externo",
      dataIndex: "external_responsible",
      key: "external_responsible",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, props) => (
        <SelectInput
          handleChange={(value) => handleCompleteAction(value, props.actionProducerId, status)}
          options={statusOptions}
          defaultValue={statusOptions?.find((item) => item?.value === status)}
          breakLine={false}
          placeholder={"Status"}
          isOverModal={true}
        />
      ),
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      width: "30px",
      render: (tags, props) => (
        <div style={{ display: "flex", flexDirection: "row", gap: 3 }}>
          <TagInput
            changeTag={(value, isNew) => changeTag(value, isNew, props)}
            optionTags={tagPossibility}
            tags={tags}
          />
          <>
            <ActionButton
              description="Comentar"
              icon={MdChat}
              onClick={() => handleOpenModalComment(props?.actionId)}
            />
            <ActionButton
              description="Excluir"
              icon={MdDelete}
              onClick={() =>
                ModalAlert.danger({
                  title: "Excluir Ação",
                  text: `Você deseja mesmo excluir esta ação ?`,
                  confirmLabel: "Sim",
                  onConfirm: () => handleDeleteAction(props),
                })
              }
            />
          </>
        </div>
      ),
    },
    {
      title: "Editar ",
      width: "30px",
      render: (props) => (
        <ActionButton
          description="Editar"
          icon={HiOutlinePencil}
          onClick={() => handleModalOpenEdit(props)}
        />
      ),
    },
  ];

}



const ActionPlanScreen = ({
  data,
  tabStatusOptions,
  indicatorTabsOptions,
  formSteps,
  editedChatFields,
  values,
  handleEdit,
  handleSave,
  handleCancel,
  loadingField,
  onChangeQuestionsInfo,
  editIndex,
  generatePlan,
  loading,
  loadingActionSave,
  loadingActionPlan,
  // currentTab,
  handleSaveAction,
  handleUpdateAction,
  onChangeValues,
  handleSelectedIndicator,
  modalOpen,
  setModalOpen,
  handleCompleteAction,
  technicalList,
  changeFilter,
  filter,
  uniqueEmails,
  changeTag,
  tagPossibility,
  setTagPossibility,
  handleActiveIndicator,
  handleModalOpenEdit,
  modalOpenEdit,
  handleDeleteAction,
  fromUsers,
  reload,
  indicators,
  exportPlan,
  statusOptions,
  setModalFilterIsOpen,
  modalFilterIsOpen,
  handleOpenModalComment,
  modalOpenChat,
  setModalOpenChat,
}) => {

  return (
    <>
      <div className="tabs-content action-plan">
        <div className="bullet-tabs-sticky">
          <div className="plan-action-header">
            <div className="header-period">
              <Input
                onChange={(e) => changeFilter("search", e.target.value)}
                value={filter?.search}
                placeholder="Pesquise pelo titulo ou pelo nome do produtor"
                hasFocus={false}
              />
            </div>
          </div>
          {/* <BulletTabs options={tabStatusOptions} onSelect={handleActiveStatus} tab={currentTab} /> */}
          <div style={{ flex: 1 }} />
          {isMobile ? (
            <div className="add-button">
              <div
                style={{ marginTop: 3, marginRight: 10 }}
                className={`system-chat-toggle ${loading && "loading"}`}
                onClick={() => generatePlan(true)}>
                <img src={systemChat} alt="system chat" />
              </div>
              <Button label="Adicionar Ação" handleClick={() => setModalOpen(true)} />
            </div>
          ) : (
            <>
              <div
                style={{ marginTop: 3, marginRight: 10, marginBottom: 0, flexWrap: "wrap" }}
                className={`system-chat-toggle ${loading && "loading"}`}
                onClick={() => generatePlan(true)}>
                <img src={systemChat} alt="system chat" />
              </div>
              <Button label="Adicionar Ação" handleClick={() => setModalOpen(true)} />
            </>
          )}
          <Button
            hiddenText
            hasIcon={<BsFiletypeXlsx size={16} />}
            label="Exportar"
            handleClick={exportPlan}
            color={isMobile ? "new_green" : "orange"}
            style={{ marginLeft: 5 }}
          />
          <div className="header-period-filter">
            <div className="filter-button-container" onClick={() => setModalFilterIsOpen(true)}>
              <IoFilterOutline className="icon-filter" />
              <text className="text-filter">Filtrar</text>
            </div>
          </div>
        </div>
        <div className="action-plan__container">
          <TaskTableContainer
            {...{
              data,
              tagPossibility,
              setTagPossibility,
              loadingActionPlan: false,
              uniqueEmails,
              fromUsers,
              reload,
              isAssistanceScreen: true,
              loadingActionPlan,
              handleActiveIndicator,
              formSteps,
              indicatorTabsOptions,
              indicators,
              statusOptions,
              handleOpenModalComment,
            }}
          />
          {/* {data.map((plan) => (
            <div className="action-plan__list">
              {plan.indicator && (
                <div className="action-plan__list-indicator">
                  <div className="indicator-header">
                    <IndicatorBadge indicatorValue={Number(plan?.value) || 0} />
                    <div className="indicator-header__title" title={plan.indicator}>
                      {plan.indicator}
                    </div>
                  </div>
                  {!plan.isComplete && 
                    <Button
                      label="Concluir"
                      variant="outline"
                      handleClick={() => handleCompleteAction(plan?.actionId)}
                    />
                  }
                </div>
              )}
              <div
                className={`action-plan__list-container${!plan.indicator ? " not-indicator" : ""}`}>
                <div className="action-plan__list-container-header">
                  <span className="action-plan__list-container-header__title" title={plan.title}>
                    {plan.title}
                  </span>
                  <div className="action-plan__list-container-header__end">
                    <span className="info">
                      {plan.isComplete ? "Concluída em:" : "Termina em:"}
                    </span>
                    <span className="date">
                      {plan.isComplete ? moment(plan.isComplete).format('DD/MM/YYYY') : moment(plan.finish_at).format('DD/MM/YYYY')}
                    </span>
                    <div className="date-button">
                      {!plan.indicator && !plan.isComplete && (
                        <Button label="Concluir" variant="outline" handleClick={() => handleCompleteAction(plan?.actionId)}/>
                      )}
                    </div>
                  </div>
                </div>
                <div className="action-plan__list-container-content">
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Onde será realizada a ação</span>
                    <p className="content-block5w2h__info">{plan.location}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Como será realizada a ação?</span>
                    <p className="content-block5w2h__info">{plan.instructions}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Porque realizará a ação?</span>
                    <p className="content-block5w2h__info">{plan.why}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Responsável</span>
                    <p className="content-block5w2h__info">{plan.email}</p>
                  </div>
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>

      {modalOpen && (
        <ActionPlanAdd
          {...{
            modalOpen,
            modalOpenEdit,
            setModalOpen,
            formSteps,
            editedChatFields,
            values,
            handleEdit,
            handleSave,
            handleCancel,
            loadingField,
            loadingActionSave,
            onChangeQuestionsInfo,
            editIndex,
            indicatorTabsOptions,
            handleSaveAction,
            handleUpdateAction,
            onChangeValues,
            handleSelectedIndicator,
            technicalList,
            handleActiveIndicator,
            handleDeleteAction,
            statusOptions,
          }}
        />
      )}

      {modalOpenChat && (
        <ActionPlanCommentAdd
          modalOpen={modalOpenChat}
          setModalOpen={setModalOpenChat}
          values={values}
          onChangeValues={onChangeValues}
        />
      )}

      {modalFilterIsOpen && (
        <ActionPlanFilter
          {...{
            modalOpen: modalFilterIsOpen,
            setModalOpen: setModalFilterIsOpen,
            changeFilter,
            filter,
            uniqueEmails,
            tagPossibility,
          }}
        />
      )}
    </>
  )
}

export default ActionPlanScreen
